import React, { useState, useEffect } from "react";

import { getSS } from '../../helpers'

const NeedHelp: React.FC = () => {

  const [ tel, setTel ] = useState('+44(0)208 332 3200')
  const [ email, setEmail ] = useState('membership@kew.org')
  const wakehurstMembership = getSS('membership')?.selected_membership?.wakehurst_membership

  useEffect(() => {
    if (wakehurstMembership) {
      setTel('+44(0)1444 894067')
      setEmail('wakehurst@kew.org')
    }
  }, [wakehurstMembership])

  return (
    <>
      <div className="need-help">
        <h2>Need help?</h2>
        <p>Please get in touch if you have any problems or questions.</p>
        <p className="tel"><a className="blue" href={`tel:${tel}`}>{tel}</a></p>
        <p className="email"><a className="blue" href={`mailto:${email}`}>{email}</a></p>

      </div>
    </>
  );
};

export default NeedHelp;